/* ===========================================================================
   AIRFORMANCE X — Codigo de descuento del cajon (v2, sin recargar)

   QUE CAMBIA RESPECTO A V1
   v1 hacia window.location.href = '/discount/CODIGO'. Eso es una navegacion:
   el cajon se cerraba, la pagina se refrescaba y el cliente perdia el sitio.
   v2 pide esa misma URL con fetch. La cookie de sesion se escribe igual —
   es la misma peticion — pero sin salir de la pagina.

   EL TRUCO DEL REDIRECT
   /discount/CODIGO?redirect=/cart.js aterriza en el carrito en JSON, asi que
   una sola peticion hace dos cosas: aplica el codigo a la sesion y devuelve
   el carrito ya recalculado. Verificado: Shopify respeta la RUTA del
   parametro redirect (descarta su query string, de ahi el sessionStorage).
   Si algun dia deja de respetarla, el catch pide /cart.js aparte: la cookie
   ya esta puesta, asi que no se pierde nada.

   LIMITE REAL DE SHOPIFY, PARA QUE NADIE LO BUSQUE OTRA VEZ
   No existe API AJAX de codigos de descuento. Los descuentos POR CODIGO los
   calcula Shopify en el checkout; los AUTOMATICOS si llegan a cart.js. Por eso
   aqui se lee el carrito y solo se promete un ahorro concreto cuando Shopify
   lo da. Nunca se dice "codigo invalido": no hay forma de distinguir un codigo
   malo de uno bueno que no se refleja en el carrito, y decirselo a un cliente
   que tiene un codigo valido cuesta mas que no decir nada.

   POR QUE VIVE AQUI Y NO DENTRO DEL SNIPPET
   El tema re-renderiza el cajon inyectando HTML en <xo-cart-will-change>.
   Dos cosas se rompen a la vez: el listener atado al boton muere con el nodo
   viejo, y un <script> que llega por innerHTML NO se ejecuta nunca (lo prohibe
   la especificacion de HTML). Resultado: funcionaba al cargar y dejaba de
   funcionar en cuanto el cliente tocaba una cantidad. Este fichero escucha en
   DOCUMENT por delegacion, asi que da igual cuantas veces se reescriba el cajon.
   =========================================================================== */
(function () {
  'use strict';

  if (window.__AFX_DC_V2) { return; }
  window.__AFX_DC_V2 = true;

  var CLAVE = 'afx_dc';
  var cargando = false;

  // ---- Estado que sobrevive al re-render del cajon ------------------------
  function guarda(obj) {
    try { window.sessionStorage.setItem(CLAVE, JSON.stringify(obj)); } catch (e) {}
  }
  function leido() {
    try { return JSON.parse(window.sessionStorage.getItem(CLAVE) || 'null'); }
    catch (e) { return null; }
  }

  // ---- Dinero: usa el formato del tema si esta, si no uno europeo ---------
  function dinero(cents) {
    try {
      if (window.Shopify && typeof Shopify.formatMoney === 'function') {
        return Shopify.formatMoney(cents, window.Shopify.money_format);
      }
    } catch (e) {}
    return (cents / 100).toFixed(2).replace('.', ',') + ' €';
  }

  // ---- Leer el ahorro del carrito -----------------------------------------
  // Se mira en tres sitios porque segun el tipo de descuento Shopify lo coloca
  // en uno u otro: total general, nivel carrito, o repartido por linea.
  function ahorro(cart) {
    if (!cart) { return 0; }
    if (typeof cart.total_discount === 'number' && cart.total_discount > 0) {
      return cart.total_discount;
    }
    var t = 0, i, apps = cart.cart_level_discount_applications || [];
    for (i = 0; i < apps.length; i++) {
      t += apps[i].total_allocated_amount || 0;
    }
    if (t > 0) { return t; }
    var items = cart.items || [], j, k;
    for (j = 0; j < items.length; j++) {
      var ds = items[j].line_level_discount_allocations || items[j].discounts || [];
      for (k = 0; k < ds.length; k++) { t += ds[k].amount || 0; }
    }
    return t;
  }

  function pideDescuento(code) {
    var url = '/discount/' + encodeURIComponent(code) + '?redirect=/cart.js';
    return fetch(url, {
      credentials: 'same-origin',
      headers: { 'Accept': 'application/json, text/plain, */*' }
    })
      .then(function (r) { return r.text(); })
      .then(function (txt) {
        try { return JSON.parse(txt); }
        catch (e) {
          // El redirect no se respeto. La cookie ya esta escrita: pedimos el
          // carrito por separado en vez de dar el intento por perdido.
          return fetch('/cart.js', { credentials: 'same-origin' })
            .then(function (r2) { return r2.json(); });
        }
      });
  }

  // ---- Repintar el cajon sin cerrarlo -------------------------------------
  // Se pide la pagina actual y se trasplanta el interior de cada region
  // <xo-cart-will-change>, que es exactamente lo que hace el tema cuando
  // cambias una cantidad. El cajon es el contenedor, no la region, asi que
  // no se cierra. Si el numero de regiones no cuadra, no se toca nada: mejor
  // un subtotal sin refrescar que un cajon reventado.
  function refresca() {
    var url = window.location.pathname + window.location.search;
    return fetch(url, { credentials: 'same-origin' })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var viejos = document.querySelectorAll('xo-cart-will-change');
        var nuevos = doc.querySelectorAll('xo-cart-will-change');
        if (!viejos.length || viejos.length !== nuevos.length) { return false; }
        for (var i = 0; i < viejos.length; i++) {
          viejos[i].innerHTML = nuevos[i].innerHTML;
        }
        return true;
      })
      .catch(function () { return false; });
  }

  // ---- Pintar el aviso ----------------------------------------------------
  function pinta() {
    var st = leido();
    if (!st || !st.c) { return; }

    var avisos = document.querySelectorAll('[data-afx-dc-ok]');
    for (var i = 0; i < avisos.length; i++) {
      var el = avisos[i];
      var attr = (st.a > 0) ? 'data-msg-ok' : 'data-msg-pend';
      var plantilla = el.getAttribute(attr) || el.getAttribute('data-msg-pend') || '{code}';
      var texto = plantilla
        .replace('{code}', st.c)
        .replace('{amount}', dinero(st.a || 0));

      // Solo se escribe si cambia: escribir siempre despertaria al observador
      // de abajo con nuestra propia mutacion, y eso es un bucle.
      if (el.textContent !== texto) { el.textContent = texto; }
      if (el.hidden) { el.hidden = false; }

      var det = el.closest('details');
      if (det && !det.open) { det.open = true; }

      var caja = el.closest('.afx-dc');
      if (caja) { caja.setAttribute('data-afx-state', st.a > 0 ? 'ok' : 'pend'); }

      var input = caja && caja.querySelector('[data-afx-dc-input]');
      if (input && !input.value) { input.value = st.c; }
    }
  }

  function espera(raiz, si) {
    if (raiz && raiz.setAttribute) {
      raiz.setAttribute('data-afx-busy', si ? '1' : '0');
    }
    var btn = raiz && raiz.querySelector ? raiz.querySelector('[data-afx-dc-apply]') : null;
    if (btn) { btn.disabled = !!si; }
  }

  function aplicar(raiz) {
    if (cargando) { return; }

    var input = raiz.querySelector('[data-afx-dc-input]');
    if (!input) { return; }

    var code = (input.value || '').trim();
    if (!code) { input.focus(); return; }

    cargando = true;
    espera(raiz, true);

    // Se quita el foco ANTES de repintar: si el input sigue enfocado cuando
    // se trasplanta el HTML, iOS deja el teclado abierto sobre un nodo muerto.
    try { input.blur(); } catch (e) {}

    pideDescuento(code)
      .then(function (cart) {
        guarda({ c: code.toUpperCase(), a: ahorro(cart) });
        return refresca();
      })
      .catch(function () {
        // Aunque falle la lectura del carrito, la cookie suele estar puesta.
        guarda({ c: code.toUpperCase(), a: 0 });
        return false;
      })
      .then(function () {
        cargando = false;
        pinta();
        var vivo = document.querySelector('.afx-dc');
        if (vivo) { espera(vivo, false); }
      });
  }

  // ---- Delegacion: se escucha en document, nunca en el boton --------------
  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) { return; }
    var btn = e.target.closest('[data-afx-dc-apply]');
    if (!btn) { return; }
    e.preventDefault();
    aplicar(btn.closest('.afx-dc') || document);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter') { return; }
    if (!e.target || !e.target.closest) { return; }
    var input = e.target.closest('[data-afx-dc-input]');
    if (!input) { return; }
    e.preventDefault();
    aplicar(input.closest('.afx-dc') || document);
  });

  // ---- Repintar cuando el tema re-renderiza el cajon ----------------------
  function arranca() {
    pinta();
    if (!('MutationObserver' in window)) { return; }
    var pendiente = null;
    new MutationObserver(function () {
      if (pendiente || cargando) { return; }
      pendiente = setTimeout(function () { pendiente = null; pinta(); }, 400);
    }).observe(document.body, { subtree: true, childList: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', arranca, { once: true });
  } else {
    arranca();
  }
})();